import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-question",
  templateUrl: "./med-icon-question.component.html",
})
export class MedIconQuestionComponent extends SvgMixinComponent {}
